import { createSelector } from 'reselect';

const getTapStory = (state) => state?.tapStory ?? {};
const getGamedayType = (state) => state.gumbo?.gameData?.game?.gamedayType ?? '';
const getTeamId = (state) => state.config?.teamId;

export const getTapStoryState = createSelector(
    [getTapStory, getGamedayType, getTeamId],
    (tapStory, gamedayType, teamId) => {
        const validGameday = gamedayType !== 'N';

        return {
            ...tapStory,
            validGameday,
            teamId
        };
    }
);
